import { HTMLAttributes } from 'react'

type Tone = 'live' | 'info' | 'success' | 'warning' | 'danger'

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: Tone
}

export function Badge({ tone = 'info', className = '', children, ...props }: BadgeProps) {
  const tones: Record<Tone, string> = {
    live: 'badge-live',
    info: 'badge bg-blue-50 text-blue-700',
    success: 'badge bg-green-50 text-green-700',
    warning: 'badge bg-yellow-50 text-yellow-700',
    danger: 'badge bg-red-50 text-red-700'
  }
  return (
    <span className={`${tones[tone]} ${className}`} {...props}>
      {children}
    </span>
  )
}